import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Language } from './Language'
import { Languages } from '@s4l/i18n/types/Languages'

export const ListOfLanguageValidation = z.object({
  list: z.instanceof(Language, { message: '[ListOfLanguage] list is required' }).array(),
})

export class ListOfLanguage extends Model {
  static create({ list }: z.infer<typeof ListOfLanguageValidation>) {
    ListOfLanguageValidation.parse({ list })
    return new ListOfLanguage(list)
  }

  static empty() {
    return new ListOfLanguage([])
  }

  static fromArray({ languages }: { languages: Languages[] }) {
    return ListOfLanguage.create({ list: languages.map(lang => Language.create({ value: lang })) })
  }

  static fromJSON({ json }: { json: ReturnType<ListOfLanguage['toJSON']> }) {
    return ListOfLanguage.create({
      list: json.list.map(languageJSON => Language.fromJSON(languageJSON)),
    })
  }

  constructor(private readonly _list: Language[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }
}
